import {Breadcrumb, ErrorEvent} from '@sentry/react';

const PotentialBlockedUrls: RegExp[] = [
  /hotjar/,
  /piwik/,
  /datadome/,
  /google-analytics/,
  /gtag/,
  /tawk/,
];

const isProbablyBlockedByAdblockUrl = (url: string) => {
  return PotentialBlockedUrls.some((regexp) => regexp.test(url));
};

const isProbablyBlockedByAdblockBreadcrumb = (breadcrumb: Breadcrumb) => {
  if (
    breadcrumb.level !== 'error' ||
    (breadcrumb.category !== 'xhr' && breadcrumb.category !== 'fetch')
  ) {
    return false;
  }

  const url = breadcrumb.data?.url as string | undefined;
  if (!url) return false;

  return isProbablyBlockedByAdblockUrl(url);
};

const isProbablyBlockedByAdblockNetworkError = (error: ErrorEvent) => {
  const now = Date.now();

  if (!error.breadcrumbs) {
    return false;
  }

  const breadcrumbs = error.breadcrumbs?.filter(Boolean);

  // We go from the back since the last breadcrumb is most likely the erroneous one
  for (let i = breadcrumbs.length - 1; i >= 0; i--) {
    const breadcrumb = error.breadcrumbs[i];

    // We only need to check the last 1s of breadcrumbs as any earlier breadcrumbs are definitely unrelated
    if (breadcrumb.timestamp && now - breadcrumb.timestamp * 1000 > 1000) {
      break;
    }

    if (isProbablyBlockedByAdblockBreadcrumb(breadcrumb)) {
      return true;
    }
  }

  return false;
};

export const shouldIgnoreError = (error: ErrorEvent) =>
  isProbablyBlockedByAdblockNetworkError(error);
